import React from "react";
import Input from "../../../../widget/common/form/Input";
import PhoneNumber from "../../../../widget/common/form/PhoneNumber";
import { SettingsPersonalProfileContextImport } from "../../../../provider/settings/manage_personal_profile/SettingsPersonalProfileContextProvider";
import { navigate } from "../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../routes/routes";
import { useDispatch } from "react-redux";
import { addModal } from "../../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../../const/ModalKeys";
import { setupGeoDetail } from "../../../../libraries/state_reducers/country_state_city_area/CountyStateCityAreaReducer";

export const FirstNameField = () => {
  const { firstNameField, profileValidate, profileErrors, handleOnChange } =
    SettingsPersonalProfileContextImport();

  return (
    <Input
      type={`text`}
      name="first_name"
      handleOnChange={handleOnChange}
      value={firstNameField}
      validate={true}
      label="first_name"
      error={!profileValidate ? profileErrors.firstNameField : false}
    />
  );
};

export const LastNameField = () => {
  const { lastNameField, profileValidate, profileErrors, handleOnChange } =
    SettingsPersonalProfileContextImport();
  return (
    <Input
      type={`text`}
      name="last_name"
      handleOnChange={handleOnChange}
      value={lastNameField}
      validate={true}
      label="last_name"
      error={!profileValidate ? profileErrors.lastNameField : false}
    />
  );
};

export const PasswordField = () => {
  const suffixHandleClick = () => {
    navigate(appRoutes.routeNameSettingsPersonalSecurityPassword);
  };

  return (
    <Input
      type={`password`}
      name="password"
      handleOnChange={() => {}}
      value={`*********`}
      label="password"
      suffixType="text"
      suffixText="change"
      suffixHandleClick={suffixHandleClick}
      disabled={true}
    />
  );
};

export const EmailField = () => {
  const { emailField } = SettingsPersonalProfileContextImport();

  const suffixHandleClick = () => {
    navigate(appRoutes.routeNameSettingsPersonalSecurityEmail);
  };

  return (
    <Input
      type="email"
      name="email"
      handleOnChange={() => {}}
      value={emailField}
      label="email"
      suffixType="text"
      suffixText="change"
      suffixHandleClick={suffixHandleClick}
      disabled={true}
    />
  );
};

export const PhoneField = () => {
  const { phoneField, phoneCodeField, handleOnChange } =
    SettingsPersonalProfileContextImport();

  const suffixHandleClick = () => {
    navigate(appRoutes.routeNameSettingsPersonalSecurityPhone);
  };

  return (
    <PhoneNumber
      name="phone_number_optional"
      handleOnChange={handleOnChange}
      value={phoneField}
      code={phoneCodeField}
      label="phone_number_optional"
      suffixType="text"
      suffixText="change"
      suffixHandleClick={suffixHandleClick}
      disabled={true}
      callback={() => {}}
    />
  );
};

export const CityField = () => {
  const dispatch = useDispatch();
  const { countryId, countryName, stateId, stateName, cityId, cityName } =
    SettingsPersonalProfileContextImport();

  const handleClickCity = () => {
    dispatch(
      addModal({
        id: ModalKeys.choose_city_of_residence,
        title: "choose_city_of_residence",
      })
    );

    dispatch(
      setupGeoDetail({
        country: { country_id: countryId, country_name: countryName },
        state: { state_id: stateId, state_name: stateName },
        city: { city_id: cityId, city_name: cityName },
      })
    );
  };

  return (
    <div role="button" onClick={handleClickCity}>
      <Input
        type={`text`}
        name="city_of_residence"
        handleOnChange={() => {}}
        value={cityName}
        label="city_of_residence"
        readOnly={true}
      />
    </div>
  );
};
